import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEnquiry({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 96 96"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <path
          d="M99 65.2A3148.58 3148.58 0 0047.88 79c-9.53-4.14-25.1-11.32-46.73-21.55A2 2 0 010 55.65V3.76a2 2 0 011.93-2l51.1-1.7a2 2 0 012.07 2v29L3.23 45.5l45.1 19.14h.02L99 52.85v12.34z"
          id="pic-enquiry_svg__c"
        />
        <path
          d="M.5 7.36c0 2.3.02 6.86 0 8.74L45.7 35l51.48-11.16s.72-4.59 0-8.33c-.52-2.66-2.03-3.97-3.87-4.42C88.86 10 48.5.5 48.5.5S.5 5.06.5 7.36z"
          id="pic-enquiry_svg__e"
        />
        <path
          d="M8.88 3.11C.3 3.11.1 7.53.74 11.86c.8 5.45.4 10.06 5.23 10.79 4.84.72 12.15-2.31 24.34-3.6 12.18-1.3 8.45-4.68 6.86-12.38-1.6-7.7-19.73-3.56-28.3-3.56z"
          id="pic-enquiry_svg__g"
        />
        <circle id="pic-enquiry_svg__a" cx={48} cy={48} r={48} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="pic-enquiry_svg__b" fill="#fff">
          <use xlinkHref="#pic-enquiry_svg__a" />
        </mask>
        <use fill="#8F9DD6" opacity={0.24} xlinkHref="#pic-enquiry_svg__a" />
        <g mask="url(#pic-enquiry_svg__b)">
          <g transform="translate(11 16)">
            <mask id="pic-enquiry_svg__d" fill="#fff">
              <use xlinkHref="#pic-enquiry_svg__c" />
            </mask>
            <use fill="#FFF" xlinkHref="#pic-enquiry_svg__c" />
            <use fillOpacity={0.8} fill="#8F9DD6" xlinkHref="#pic-enquiry_svg__c" />
            <path
              d="M0 60V1h3v44.86L48.2 65v16.06L1.5 60H0z"
              fillOpacity={0.5}
              fill="#8F9DD6"
              mask="url(#pic-enquiry_svg__d)"
            />
          </g>
        </g>
        <g mask="url(#pic-enquiry_svg__b)">
          <g transform="translate(13.5 46)">
            <mask id="pic-enquiry_svg__f" fill="#fff">
              <use xlinkHref="#pic-enquiry_svg__e" />
            </mask>
            <use fill="#FFF" xlinkHref="#pic-enquiry_svg__e" />
            <use fillOpacity={0.5} fill="#FCC083" xlinkHref="#pic-enquiry_svg__e" />
            <path
              d="M-1 6.5c28.09 11.42 43.39 17.48 45.9 18.18.44.12.7.55.8 1.28v9.71L-1 15.57V6.5z"
              fillOpacity={0.2}
              fill="#FCC083"
              mask="url(#pic-enquiry_svg__f)"
            />
          </g>
        </g>
        <path
          d="M14 53.36c17.86 8.1 32.53 13.78 44.02 17.04 1.19.34 2.18.37 2.98.1 0 0 36.72-7.55 48.77-9.76 1.23-.23-2.7-3.86-4.87-4.35C102.72 55.89 67.44 46 64.2 46c-2.97 0-49.1 3.83-50.2 7.36z"
          fill="#FFF"
          mask="url(#pic-enquiry_svg__b)"
        />
        <g mask="url(#pic-enquiry_svg__b)">
          <g transform="translate(21 31)">
            <use fill="#FFF" xlinkHref="#pic-enquiry_svg__g" />
            <use fillOpacity={0.5} fill="#FCC083" xlinkHref="#pic-enquiry_svg__g" />
          </g>
          <path
            d="M23.33 37.8c0 1.67 1.85 10.92 2.66 12.2.8 1.27 1.75 1.41 3.13 1.41 1.37 0 27.35-3.38 28.71-4 1.37-.62 1.84-1.84 1.83-3.08 0-1.24-1.55-9.64-2.18-10.92-.62-1.28-1.61-1.85-3.35-1.57-1.73.27-27.08 2.88-28.42 3.2-1.33.32-2.38 1.1-2.38 2.76z"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicEnquiry.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEnquiry.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicEnquiry svgRef={ref} {...props} />);
export default ForwardRef;
